/**
 * Bottom help banner: technical-support form link and referent phone.
 */
import * as React from 'react';
import { Button } from '@/components/forms/Button';
import {
  HELP_SUPPORT_BANNER_CTA,
  HELP_SUPPORT_BANNER_PHONE_LEAD,
  HELP_SUPPORT_BANNER_TITLE,
} from './tutorial-configs';
import { tutorialPhoneHref } from './tutorial-grid-utils';

/** Props for {@link HelpSupportBanner}. */
type HelpSupportBannerProps = Readonly<{
  formUrl: string;
  phone: string;
  canEdit: boolean;
  onEdit: () => void;
}>;

/** Mode-specific help strip under the tutorial grid. */
export function HelpSupportBanner({
  formUrl,
  phone,
  canEdit,
  onEdit,
}: HelpSupportBannerProps): React.ReactElement {
  function renderEditButton(): React.ReactNode {
    if (!canEdit) return null;
    return (
      <div className="absolute top-2 right-2">
        <Button preset="row-edit" onClick={onEdit} />
      </div>
    );
  }

  return (
    <div
      className="relative rounded-lg border p-6 mt-8"
      style={{
        borderColor: 'var(--color-1-nuance-1)',
        backgroundColor: 'color-mix(in srgb, var(--color-1-nuance-1) 8%, transparent)',
      }}
    >
      {renderEditButton()}
      <div className="flex flex-wrap items-center gap-4 mb-4 pr-10">
        <h3 className="text-xl font-bold" style={{ color: 'var(--color-1-nuance-2)' }}>
          {HELP_SUPPORT_BANNER_TITLE}
        </h3>
        <a href={formUrl} target="_blank" rel="noopener noreferrer">
          <Button type="button" variant="primary" size="lg" className="shrink-0">
            {HELP_SUPPORT_BANNER_CTA}
          </Button>
        </a>
      </div>

      <p className="text-base text-foreground">
        {HELP_SUPPORT_BANNER_PHONE_LEAD}
        <a
          href={tutorialPhoneHref(phone)}
          className="font-semibold hover:underline"
          style={{ color: 'var(--color-1-nuance-2)' }}
        >
          {`${phone}.`}
        </a>
      </p>
    </div>
  );
}
